import {FC, useState, useEffect} from 'react'
import {Link, useLocation} from 'react-router-dom'
import {KTSVG, checkIsActive} from '../../../_metronic/helpers'
import {MenuItem} from '../../types/MenuItem'
import {mapearIconesDeSecoes, HOME_ICON} from './icons'

type Props = {
  items: MenuItem[]
}

// Um item contém a rota ativa em qualquer profundidade?
const containsActive = (item: MenuItem, pathname: string): boolean => {
  if (item.to && checkIsActive(pathname, item.to)) return true
  return (item.children || []).some((child) => containsActive(child, pathname))
}

const Leaf: FC<{item: MenuItem; depth: number}> = ({item, depth}) => {
  const {pathname} = useLocation()
  const isActive = item.to ? checkIsActive(pathname, item.to) : false
  return (
    <Link
      to={item.to || '#'}
      className={`sb-link ${isActive ? 'active' : ''} ${depth > 0 ? 'sb-link-sub' : ''}`}
    >
      <span className='sb-label'>{item.label}</span>
    </Link>
  )
}

const Accordion: FC<{item: MenuItem; depth: number}> = ({item, depth}) => {
  const {pathname} = useLocation()
  const hasActive = containsActive(item, pathname)
  const [open, setOpen] = useState(hasActive)

  // abrir automaticamente ao navegar para uma rota interna
  useEffect(() => {
    if (hasActive) setOpen(true)
  }, [hasActive])

  return (
    <div className={`sb-accordion ${open ? 'open' : ''}`}>
      <button
        type='button'
        className={`sb-link sb-accordion-toggle ${hasActive ? 'here' : ''}`}
        onClick={() => setOpen((v) => !v)}
      >
        <span className='sb-label'>{item.label}</span>
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 sb-chevron' />
      </button>
      <div className='sb-accordion-body'>
        <div className='sb-accordion-inner'>
          {(item.children || []).map((child) => (
            <Node key={`${child.label}_${child.to}`} item={child} depth={depth + 1} />
          ))}
        </div>
      </div>
    </div>
  )
}

const Node: FC<{item: MenuItem; depth: number}> = ({item, depth}) => {
  if (item.children && item.children.length) return <Accordion item={item} depth={depth} />
  return <Leaf item={item} depth={depth} />
}

const SidebarMenu: FC<Props> = ({items}) => {
  const {pathname} = useLocation()
  const homeActive = checkIsActive(pathname, '/home')
  // resolvido para o menu inteiro de uma vez: duas seções nunca repetem ícone
  const icones = mapearIconesDeSecoes(items.filter((i) => i.isSection).map((i) => i.label))

  return (
    <nav className='sb-nav'>
      <Link to='/home' className={`sb-link sb-home ${homeActive ? 'active' : ''}`}>
        <KTSVG path={HOME_ICON} className='svg-icon-2 sb-icon' />
        <span className='sb-label'>Página Inicial</span>
      </Link>

      {items.map((section) =>
        section.isSection ? (
          <div className='sb-section' key={`${section.label}_section`}>
            <div className='sb-section-header' title={section.label}>
              <KTSVG path={icones[section.label]} className='svg-icon-2 sb-icon' />
              <span className='sb-section-title'>{section.label}</span>
            </div>
            <div className='sb-section-body'>
              {(section.children || []).map((child) => (
                <Node key={`${child.label}_${child.to}`} item={child} depth={0} />
              ))}
            </div>
          </div>
        ) : (
          <Node key={`${section.label}_${section.to}`} item={section} depth={0} />
        )
      )}
    </nav>
  )
}

export {SidebarMenu}
